import React from 'react';
import SortableHeader from '../common/SortableHeader';
import Pagination from '../common/Pagination';
import LoadingSpinner from '../common/LoadingSpinner';
import CardThumbnail from '../common/CardThumbnail';
import TcgCardFilters from './TcgCardFilters';

const COLUMNS = [
  { key: 'name', label: 'Name' },
  { key: 'set_id', label: 'Set' },
  { key: 'number', label: 'No.' },
  { key: 'rarity', label: 'Rarity' },
  { key: 'artist', label: 'Illustrator' },
  { key: 'supertype', label: 'Type' },
];

export default function TcgCardTable({
  cards, total, pages, page, setPage,
  sortBy, sortOrder, toggleSort,
  filters, updateFilters,
  loading, error,
}) {
  return (
    <div className="card-table-container">
      <TcgCardFilters filters={filters} onFilterChange={updateFilters} />

      {error && <div className="error-message">{error}</div>}

      {loading ? (
        <LoadingSpinner text="Loading TCG cards..." />
      ) : cards.length === 0 ? (
        <div className="empty-state">
          <p>No TCG cards found. Click "Populate from API" to fetch card data from pokemontcg.io.</p>
        </div>
      ) : (
        <>
          <div className="table-wrapper">
            <table className="card-table">
              <thead>
                <tr>
                  <th className="col-image"></th>
                  {COLUMNS.map((col) => (
                    <SortableHeader
                      key={col.key}
                      label={col.label}
                      column={col.key}
                      sortBy={sortBy}
                      sortOrder={sortOrder}
                      onSort={toggleSort}
                    />
                  ))}
                </tr>
              </thead>
              <tbody>
                {cards.map((card) => (
                  <tr key={card.id}>
                    {/* Image thumbnail */}
                    <td className="cell-image">
                      {card.image_small ? (
                        <CardThumbnail
                          src={card.image_small}
                          largeSrc={card.image_large || card.image_small}
                          alt={card.name}
                        />
                      ) : (
                        <div className="card-thumbnail-placeholder">?</div>
                      )}
                    </td>
                    {/* Name */}
                    <td className="cell-name" title={card.name}>
                      {card.name}
                      {card.subtypes && (
                        <span className="tcg-subtypes"> ({card.subtypes})</span>
                      )}
                      {card.fr_name && card.fr_name !== card.name && (
                        <div className="tcg-fr-name">{card.fr_name}</div>
                      )}
                    </td>
                    {/* Set */}
                    <td>{card.set_id}</td>
                    {/* Number */}
                    <td>{card.number}</td>
                    {/* Rarity */}
                    <td>
                      {card.rarity ? (
                        <span className="rarity-badge tcg-rarity">
                          {card.rarity}
                        </span>
                      ) : '\u2014'}
                    </td>
                    {/* Artist */}
                    <td>{card.artist || '\u2014'}</td>
                    {/* Supertype + types */}
                    <td>
                      {card.supertype || '\u2014'}
                      {card.types && (
                        <span className="tcg-types"> ({card.types})</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pagination
            page={page}
            pages={pages}
            total={total}
            onPageChange={setPage}
          />
        </>
      )}
    </div>
  );
}
